import React, { useContext, useMemo } from 'react';
import { Justify } from 'tea-component';
import PercentageItem from '@/pages/opinion/components/Snippets/PercentageItem';
import RingRatioBubble from '@/pages/opinion/components/Snippets/RingRatioBubble';
import Tips from '@/pages/opinion/components/Snippets/Tips';
import MiniChart from '@/pages/opinion/pages/Summary/components/MiniChart';
import {
  indicatorsMap,
  dealwithEChartYFuncMap,
} from '@/pages/opinion/pages/Summary/constants';
import { FilterContext } from '@/pages/opinion/pages/Summary/context';
import {
  getQOQText,
  formatDateFunc,
  formatSameDayFunc,
} from '@/pages/opinion/utils/time';
import './index.scss';
import { useIntl } from 'umi';
import { NO_DATE } from '@/pages/opinion/constants';
import { reviewsFormat } from '@op/utils/value';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
export default function TopicTier({
  onClick,
  active,
  id,
  loading,
  apiError,
  valueKey,
  chartData,
  show,
  tableData,
  filter,
}: any) {
  const { transTopic, clickTopicToFeedsFunc } = useContext(FilterContext);
  const { formatMessage } = useIntl();

  const { x, y } = useMemo(() => {
    return (
      chartData || {
        x: [],
        y: [],
      }
    );
  }, [chartData, id]);

  const { valueRightElement, value } = useMemo(() => {
    const { start_time, end_time, date_type } = filter;
    const {
      mentions,
      mentions_old,
      mentions_qoq,
      newTimes,
      oldTimes,
      oldWeekTime,
      mentions_week,
      mentions_week_qoq,
    } = tableData || {};

    const { isSingleDay, text } = getQOQText(date_type, start_time, end_time);

    let DODElement = (titleText: string = 'DoD') => (
      <div className="dbo-text-dod">
        {isSingleDay && (
          <span className="dbo-text-desc">
            {formatMessage({ id: titleText })}
          </span>
        )}
        <RingRatioBubble
          formateValue={reviewsFormat}
          formateDate={formatSameDayFunc(filter)}
          oldTime={oldTimes}
          newTime={newTimes}
          oldValue={mentions_old}
          newValue={mentions}
          title={
            formatMessage({ id: indicatorsMap[valueKey] }) +
            ' ' +
            formatMessage({ id: titleText })
          }
        >
          <PercentageItem percentage={mentions_qoq}></PercentageItem>
        </RingRatioBubble>
      </div>
    );

    let WOWElement = (
      <div className="dbo-text-wow">
        <span className="dbo-text-desc">{formatMessage({ id: 'WoW' })}</span>
        <RingRatioBubble
          formateValue={reviewsFormat}
          formateDate={formatDateFunc(date_type)}
          oldTime={oldWeekTime}
          newTime={newTimes}
          oldValue={mentions_week}
          newValue={mentions}
          title={
            formatMessage({ id: indicatorsMap[valueKey] || ' ' }) +
            ' ' +
            formatMessage({ id: 'WoW' })
          }
        >
          <PercentageItem percentage={mentions_week_qoq}></PercentageItem>
        </RingRatioBubble>
      </div>
    );

    return {
      valueRightElement: (
        <div className="dbo-value-box-right">
          {DODElement(text)}
          {isSingleDay && WOWElement}
        </div>
      ),
      value: mentions,
    };
  }, [tableData, filter, formatMessage]);

  const title = transTopic(id, 'L2');

  return (
    <div
      onClick={onClick}
      className={`topic-tier-wrapper ${active ? 'active' : ''}`}
    >
      <Justify
        left={<h3 className="topic-tier-wrapper-title">{title}</h3>}
        right={
          <span
            onClick={(e) => {
              e.stopPropagation();
              clickTopicToFeedsFunc(id, 'L2');
              buriedBtnPoint('STO_detailsToFeeds');
            }}
            className="topic-tier-wrapper-detail"
          >
            {formatMessage({ id: 'Details' })}
          </span>
        }
      />
      <Tips
        noData={value === 0 && y.length === 0}
        loading={loading || !show}
        apiError={apiError}
        noDateText={NO_DATE.SELECTION}
        className={
          (value === 0 && y.length === 0) || loading || apiError || !show
            ? 'topic-tier-wrapper-tips'
            : ''
        }
      >
        <>
          <div className="dbo-value-box">
            <p className="dbo-value-box-left">{reviewsFormat(value)}</p>
            {valueRightElement}
          </div>

          <MiniChart
            dealwithYFunc={dealwithEChartYFuncMap[valueKey]}
            dealwithValueFunc={(value: number) => reviewsFormat(value)}
            dateType={filter.date_type}
            rightTitle={title}
            statistics={{ x, y }}
            text={formatMessage({ id: indicatorsMap[valueKey] })}
          ></MiniChart>
        </>
      </Tips>
    </div>
  );
}
